import React, {useState} from "react";

interface DecodedJWT {
    header: any;
    payload: any;
    signature: string;
}

function JWTDecoder() {
    const [jwt, setJwt] = useState<string>("");
    const [decodedToken, setDecodedToken] = useState<DecodedJWT | null>(null);
    const [error, setError] = useState<string>("");

    const decodeJWT = () => {
        setError("");
        if (!jwt.trim()) {
            setDecodedToken(null);
            return;
        }

        try {
            const parts = jwt.split('.');
            if (parts.length !== 3) {
                throw new Error("Invalid JWT format");
            }

            const decoded: DecodedJWT = {
                header: JSON.parse(atob(parts[0])),
                payload: JSON.parse(atob(parts[1])),
                signature: parts[2]
            };

            setDecodedToken(decoded);
        } catch (err) {
            setError("Invalid JWT token. Please check the format and try again.");
            setDecodedToken(null);
        }
    };

    // Handle Enter key press
    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            decodeJWT();
        }
    };

    const formatJSON = (obj: any): string => {
        return JSON.stringify(obj, null, 2);
    };

    return (
        <div className="tool">
            <h2>JWT Decoder</h2>
            <div className="content">
                <div className="jwt-decoder">
                    <div className="jwt-decoder__input-section">
                        <div className="jwt-decoder__input-container">
                            <input
                                type="text"
                                value={jwt}
                                onChange={(e) => {
                                    setJwt(e.target.value);
                                    if (!e.target.value.trim()) {
                                        setDecodedToken(null);
                                    }
                                }}
                                onKeyPress={handleKeyPress}
                                placeholder="Enter JWT token"
                                className="jwt-decoder__input"
                            />
                            <button 
                                onClick={() => setJwt("")}
                                className="jwt-decoder__clear-button"
                            >
                                Clear
                            </button>
                        </div>

                        <button 
                            onClick={decodeJWT}
                            className="jwt-decoder__convert-button"
                        >
                            Decode
                        </button>
                    </div>

                    <div className="jwt-decoder__results">
                        {error && <p className="error-message">{error}</p>}
                        {decodedToken && (
                            <>
                                <div>
                                    <p><strong>Header:</strong></p>
                                    <pre>{formatJSON(decodedToken.header)}</pre>
                                </div>
                                <div>
                                    <p><strong>Payload:</strong></p>
                                    <pre>{formatJSON(decodedToken.payload)}</pre>
                                </div>
                                <div>
                                    <p><strong>Signature:</strong></p>
                                    <pre>{decodedToken.signature}</pre>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JWTDecoder; 